import React from 'react'
import classes from './Search.module.sass'
import close from '../../../../assets/images/icons/close.svg'
import { useSelector } from 'react-redux'
import { selectDarkTheme } from '../../../../store/slices/settingsSlice'

type Props = {
  onChange: (value: string) => void
  clear: () => void
  placeHolder?: string
  value: string
}

const Search = ({ onChange, clear, placeHolder, value }: Props) => {
  const dark = useSelector(selectDarkTheme)

  return (
    <div className={classes.Container}>
      <input
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => onChange(e.target.value)}
        value={value}
        className={dark ? classes.InputDark : classes.Input}
        placeholder={placeHolder ? placeHolder : 'Введите текст для поиска'}
      />
      {value.length > 0 && (
        <div className={classes.ClearAnchor}>
          <img className={classes.Icon} src={close} onClick={clear} alt="Очистить" />
        </div>
      )}
    </div>
  )
}

export default Search
